import { useDispatch } from 'react-redux'
import { useEffect, useMemo } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useLocation } from 'react-router-dom'
import Button from 'builder/components/Button'
import { Icon20 } from 'builder/components/Icon'
import {
  AutoTailoringMode,
  parseAutoTailoringUrlParams,
  actions as resumeEditorActions,
} from 'builder/modules/resumeEditor'
import ModalOverlay from 'builder/components/ModalOverlay'
import { useQueryParam } from 'builder/hooks/useQueryParam'
import { useI18n } from 'builder/hooks/useI18n'
import * as Styled from './styles'

const SelfTailorResumeModal = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { i18n } = useI18n()
  const [showModal, closeModal] = useQueryParam('show_self_tailor_modal')
  const { mode, resumeId, jobCardId } = useMemo(
    () => parseAutoTailoringUrlParams(location.search),
    [location.search],
  )
  const isModalOpen = showModal === 'true' && !!mode && !!resumeId

  const handleClose = () => {
    closeModal(null)
    trackInternalEvent('click_tailor_manually', {
      label: 'skip',
    })
  }

  const handleCancel = () => {
    handleClose()

    if (!resumeId) return

    if (mode === AutoTailoringMode.fromMemberJB) {
      dispatch(
        resumeEditorActions.cancelAutoTailorForMemberJobBoard({ tailoredResumeId: resumeId }),
      )
    }
  }

  const handleConfirm = () => {
    if (!resumeId) return

    dispatch(
      resumeEditorActions.skipAutoTailorForJobBoard({
        mode: AutoTailoringMode.fromMemberJB,
        tailoredResumeId: resumeId,
        jobCardId,
        shouldRemoveAutoTailoredResume: mode === AutoTailoringMode.fromMemberJB,
      }),
    )
  }

  useEffect(() => {
    if (isModalOpen) {
      trackInternalEvent('show_manual_tailoring_modal')
    }
  }, [isModalOpen])

  if (!isModalOpen) {
    return null
  }

  return (
    <ModalOverlay
      onClick={handleClose}
      backgroundOpacity={0.6}
      overlayFadeDuration={350}
      contentSlideDuration={350}
    >
      <Styled.ModalContainer>
        <Styled.ModalContent>
          <Styled.ModalHeader>
            <Styled.Heading>
              {i18n.t(`builder.auto_tailoring.self_tailor_modal.header`)}
            </Styled.Heading>
            <Styled.Close onClick={handleClose}>
              <Icon20.Close />
            </Styled.Close>
          </Styled.ModalHeader>
          <Styled.SubHeading>
            {i18n.t(`builder.auto_tailoring.self_tailor_modal.body`)}
          </Styled.SubHeading>
          <Styled.ButtonContainer>
            <Button theme="ghost" onClick={handleCancel}>
              {i18n.t(`builder.auto_tailoring.self_tailor_modal.cancel`)}
            </Button>
            <Button onClick={handleConfirm}>
              {i18n.t(`builder.auto_tailoring.self_tailor_modal.confirm`)}
            </Button>
          </Styled.ButtonContainer>
        </Styled.ModalContent>
      </Styled.ModalContainer>
    </ModalOverlay>
  )
}

export default SelfTailorResumeModal
